export const SALPrinterActions = {
    RESET_RESPONSE: "RESET_RESPONSE",
    CHANGE_PRINTER:"CHANGE_PRINTER",
    CHANGE_PRINTER_SUCCESS:"CHANGE_PRINTER_SUCCESS",
    CHANGE_PRINTER_SUCCESS_RESET:"CHANGE_PRINTER_SUCCESS_RESET",
    INDUCT_WITHOUT_PRINTER: "INDUCT_WITHOUT_PRINTER",
    GET_SAL_FORMAT: "GET_SAL_FORMAT",
    GET_SAL_FORMAT_RESPONSE: "GET_SAL_FORMAT_RESPONSE",
    GET_SAL_FORMAT_RESPONSE_ERROR: "GET_SAL_FORMAT_RESPONSE_ERROR",
    LOADING: "LOADING"
};


// WEBPACK FOOTER //
// ./src/components/scanPrinter/actions/SALPrinterActions.js